import { getReportTableRowKeys } from '../../redux/reducers/ReportTableRowReducer';
import { methodResult } from '../TableCells';

const KEY_NAME = 0;
const VALUE_NAME = 1;

export const rowData = () => {
  const row: { [key: string]: number[] } = {};
  getReportTableRowKeys().forEach((displayKey) => {
    row[displayKey] = [];
  });
  return row;
};

export const columnKeys = (viewColumns: string[][]): string[] => {
  const columnKeys: string[] = [];
  viewColumns.forEach((col) => {
    columnKeys.push(col[KEY_NAME]);
  });
  return columnKeys;
};

export const columnDisps = (viewColumns: string[][]): { [key: string]: string } => {
  const columnDisps: { [key: string]: string } = {};
  viewColumns.forEach((col) => {
    columnDisps[col[KEY_NAME]] = col[VALUE_NAME];
  });
  return columnDisps;
};

export function addRowTotalAndColumnTotal(dtoToViewTable: methodResult, viewRow: string[]) {
  const data: {
    [key: string]: number[];
  } = dtoToViewTable.data;
  data.total = dtoToViewTable.columnTotal;
  data.total.push(
    dtoToViewTable.columnTotal.reduce(function (sum, element) {
      return sum + element;
    }, 0)
  );

  viewRow.forEach((key: string) => {
    data[key].push(dtoToViewTable.rowTotal[key]);
  });

  return data;
}

export function addRowTotal(dtoToViewTable: methodResult) {
  const data: {
    [key: string]: number[];
  } = dtoToViewTable.data;
  data.total = dtoToViewTable.columnTotal;

  return data;
}

export interface TableDataProps {
  header: string[];
  headerDisp: { [key: string]: string };
  data: { [key: string]: number[] };
}